/**
 * "Lembrar de mim" da tela de entrar.
 *
 * Marcado (padrão), a sessão do Supabase fica no `localStorage` e sobrevive a fechar o
 * navegador. Desmarcado, fica no `sessionStorage` e acaba com a aba. A escolha é gravada
 * ANTES do login, e o armazenamento do cliente lê a escolha a cada gravação — assim a
 * sessão nasce no lugar certo, sem recriar o cliente.
 */

const CHAVE = 'vec.lembrar';

export function lembrarSessao(): boolean {
    try {
        return localStorage.getItem(CHAVE) !== 'nao';
    } catch {
        return true;
    }
}

export function definirLembrarSessao(lembrar: boolean): void {
    try {
        if (lembrar) localStorage.removeItem(CHAVE);
        else localStorage.setItem(CHAVE, 'nao');
    } catch {
        /* Sem armazenamento (janela privada restrita): vale o padrão, que é lembrar. */
    }
}

/** O armazenamento que o cliente do Supabase usa para a sessão. */
export const armazenamentoDaSessao = {
    getItem(chave: string): string | null {
        try {
            return sessionStorage.getItem(chave) ?? localStorage.getItem(chave);
        } catch {
            return null;
        }
    },
    setItem(chave: string, valor: string): void {
        try {
            /* Grava num lugar e apaga do outro: trocar a escolha entre dois logins não
               deixa a sessão antiga esquecida no armazenamento que não vale mais. */
            if (lembrarSessao()) {
                localStorage.setItem(chave, valor);
                sessionStorage.removeItem(chave);
            } else {
                sessionStorage.setItem(chave, valor);
                localStorage.removeItem(chave);
            }
        } catch {
            /* Armazenamento cheio ou bloqueado: a sessão vale só enquanto a página estiver aberta. */
        }
    },
    removeItem(chave: string): void {
        try {
            localStorage.removeItem(chave);
            sessionStorage.removeItem(chave);
        } catch {
            /* Nada a remover onde não há armazenamento. */
        }
    },
};
